import React, { useCallback, useMemo } from 'react'

import * as Analytics from 'analytics/analytics'
import { tourExploreCategory } from 'analytics/snowplow/events'

import CategoryTile from 'components/Luxkit/CategoryTile'
import styled from 'styled-components'
import { rem } from 'polished'
import qs from 'qs'
import Places from 'constants/places'

interface Props {
  category: Tours.CategoryData;
}

const CategoryTourWrapper = styled(CategoryTile)`
  width: ${rem(180)};
`

function TourPageCategoryTile(props: Props) {
  const { category } = props

  const categorySearchUrl = useMemo(() => {
    const { parameterName, parameterValue } = category

    const queryString = qs.stringify({
      [parameterName]: parameterValue,
      destinationId: Places.Anywhere.id,
      destinationName: Places.Anywhere.name,
    }, {
      arrayFormat: 'comma',
    })

    return `/search/tours?${queryString}`
  }, [category])

  const image = useMemo((): App.Image => ({
    id: category.imageId,
    title: category.name,
  }), [category])

  const handleClick = useCallback(() => Analytics.track('tour-event', tourExploreCategory(category.name.toLowerCase().replaceAll(' ', '_'))), [category.name])

  return <CategoryTourWrapper
    onClick={handleClick}
    to={categorySearchUrl}
    image={image}
    heading={category.name}
    subHeading={category.subText}
    align="top"
    callToAction="View offers"
  />
}

export default TourPageCategoryTile
